export { default as DetallePaletizacion } from "./DetallePaletizacion";

